<template>
  <div :class="[inline ? 'd-inline' : 'd-flex', 'justify-content-between', expandMobile ? 'flex-grow-1 pl-2' : '']">
    <router-link v-if="showLinks" tag="button" :to="{ name: this.link, params: { details: this.row, draftId: resolvedDraftId, eventId: resolvedEventId, edit, slug, tab, score, secretary, id } }" :class="['btn btn-link text-wrap text-left p-0', buttonBreak ? 'text-break' : '', expandMobile ? 'btn-expand-sm' : '']">{{ text }}</router-link>
    <a :href="'tel:' + mobile" class="" v-else-if="isMobile">{{ text }}</a>
    <span v-else-if="hasSeasons">
      <span v-for="(value, key, index) in row.seasons" :key="key">
        <span :class="['badge ml-1 my-auto', {'alert-danger': value === 0, 'alert-success': value === 1}]">{{ key }}</span>
      </span>
    </span>
    <span v-else :class="[textBreak ? 'text-break' : '']">{{ text }}</span>
    <span :class="['badge ml-1 my-auto', row.membership_status === 'Lifetime' ? 'alert-info' : row.membership_status === 'Archived' ? 'alert-dark' : 'alert-danger']" v-if="showActive && row.membership_status !== 'Active'">{{row.membership_status === 'Onhold' ? 'On Hold' : row.membership_status}}</span>
    <span :class="['badge ml-1 my-auto', !!isFinancial ? 'alert-info' : 'alert-warning']" v-else-if="showActive">{{!!isFinancial ? 'Financial' : 'Unfinancial'}}</span>
    <span :class="['badge ml-1 my-auto', !!row.is_active ? 'alert-success' : 'alert-danger']" v-else-if="showActiveToken">{{!!row.is_active ? 'Active' : 'Unactive'}}</span>
    <span :class="['badge ml-1 my-auto', !!row.is_financial ? 'alert-info' : 'alert-warning']" v-if="showFinancial">{{!!row.is_financial ? 'Financial' : 'Unfinancial'}}</span>
    <span :class="['badge ml-auto my-auto', row.active ? 'alert-success' : 'alert-warning']" v-if="showHorseActive">{{row.active ? 'Active' : 'Archived'}}</span>
    <span :class="['badge ml-auto my-auto', row.role === 'SecretaryOnly' ? 'alert-info' : 'alert-warning']" v-if="showSecretaryOnly">{{row.role === 'SecretaryOnly' ? 'Secretary Only' : 'Member Secretary'}}</span>
    <span :class="['badge ml-1 my-auto', row.registration_date ? 'alert-info' : 'alert-warning']" v-if="showRegistered">{{row.registration_date ? 'Registered' : 'Unregistered'}}</span>
    <span :class="['badge ml-1 my-auto alert-warning']" v-if="showFinal && row.is_final">Final</span>
    <span :class="['badge ml-1 my-auto', row.status === 'paid' ? 'alert-info' : 'alert-warning']" v-if="showPaid">{{row.status === 'paid' ? 'Paid' : 'Pending'}}</span>
    <span :class="['badge ml-1 my-auto', $store.getters.getDraftStatus(row.draft_status_id) === 'Published' ? 'alert-success' : $store.getters.getDraftStatus(row.draft_status_id) === 'Pending' ? 'alert-info' : $store.getters.getDraftStatus(row.draft_status_id) === 'Postponed' ? 'alert-warning' : 'alert-danger']" v-if="showStatus && row.draft_status_id && $store.state.listDraftStatus.length > 0">
      <svg title="Finalised" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="12" class="ml-auto mr-1 text-success" v-if="row.points_status === 'finalised' && $store.getters.getDraftStatus(row.draft_status_id) === 'Published'"><path fill="currentColor" d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>
      {{$store.getters.getDraftStatus(row.draft_status_id)}}
    </span>
    <span :class="['badge ml-1 my-auto', row.status === 'Finalised' ? 'alert-success' : row.status === 'Pending' ? 'alert-info' : 'alert-warning']" v-else-if="showStatus">{{row.status}}</span>
    <span :class="['badge ml-1 my-auto', row.status === 'denied' ? 'alert-danger' : (row.status === 'approved' ? 'alert-success' : 'alert-warning')]" v-else-if="showJudgeStatus">{{ row.status[0].toUpperCase() + row.status.slice(1) }}</span>
    <span class="badge alert-prim my-auto ml-2" v-if="!row.parent_id && showPrimary">Primary</span>
    <span class="badge alert-danger my-auto ml-2" v-if="showDeleted && row.deleted_at">Deleted</span>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
    link: String,
    row: Object,
    options: Object,
    edit: Boolean,
    slug: {
      default: '',
      required: false
    },
    tab: String,
    score: Boolean,
    secretary: Boolean,
    mobile: String,
    draftId: {
      default: null,
      required: false
    },
    id: {
      default: undefined,
      required: false
    }
  },
  computed: {
    resolvedDraftId() {
      if (this.draftId !== null && this.draftId !== undefined) {
        return this.draftId
      }
      if (this.link === 'Events') {
        return this.row.id
      }
      if (this.link === 'Create Event') {
        return this.row.draft_id
      }
      return undefined
    },
    resolvedEventId() {
      return this.link === 'Create Event' ? this.row.id : undefined
    }
  },
  data() {
    return {
      showLinks: this.options && this.options.showLinks,
      showActive: this.options && this.options.showActive,
      showActiveToken: this.options && this.options.showActiveToken,
      showHorseActive: this.options && this.options.showHorseActive,
      showRegistered: this.options && this.options.showRegistered,
      showPrimary: this.options && this.options.showPrimary,
      showPaid: this.options && this.options.showPaid,
      showStatus: this.options && this.options.showStatus,
      inline: this.options && this.options.inline,
      expandMobile: this.options && this.options.expandMobile,
      textBreak: this.options && this.options.textBreak,
      buttonBreak: this.options && this.options.buttonBreak,
      showFinal: this.options && this.options.showFinal,
      hasSeasons: this.options && this.options.hasSeasons,
      showSecretaryOnly: this.options && this.options.showSecretaryOnly,
      showDeleted: this.options && this.options.showDeleted,
      isFinancial: this.row.isFinancial !== undefined ? this.row.isFinancial : this.row.financial,
      isMobile: this.options && this.options.isMobile && this.mobile,
      showJudgeStatus: this.options && this.options.showJudgeStatus,
      showFinancial: this.options && this.options.showFinancial
    }
  },
  watch: {
    row: {
      deep: true,
      handler() {
        this.isFinancial = this.row.isFinancial !== undefined ? this.row.isFinancial : this.row.financial
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DataTableFields/Text.vue